export default "<div class=\"card\">\n  <div class=\"card-block\">\n    <span>Sorry, the page you're looking for doesn't exist.</span>\n  </div>\n</div>\n";